import {
  DEBTLOAD_LIST_FAILED,
  DEBTLOAD_LIST_REQUEST,
  DEBTLOAD_LIST_SUCCESS,
  GET_DEBT_LOAD_GROUP_REQUEST,
  GET_DEBT_LOAD_GROUP_SUCCESS,
  UPDATE_DEBT_LOAD_GROUP_FAILURE,
  UPDATE_DEBT_LOAD_GROUP_REQUEST,
  UPDATE_DEBT_LOAD_GROUP_SUCCESS,
  FETCH_DEBT_LOAD_CALCULATE_REQUEST,
  FETCH_DEBT_LOAD_CALCULATE_SUCCESS,
  FETCH_DEBT_LOAD_CALCULATE_FAILED,
  GET_CLIENT_LAST_DEBT_LOAD_REQUEST,
  GET_CLIENT_LAST_DEBT_LOAD_SUCCESS,
  GET_CLIENT_LAST_DEBT_LOAD_FAILED,
  GENERATE_DEBT_OVERLOAD_REPORT,
  IS_SIGNED_NOTIFICATION,
  RESET_DEBT_LOAD_CALCULATE,
  FETCH_DEBT_LOAD_REPORT_REQUEST,
  FETCH_DEBT_LOAD_REPORT_SUCCESS,
  FETCH_DEBT_LOAD_REPORT_FAILED,
  CALCULATE_DEBT_LOAD_REQUEST,
} from "./actionTypes";

export const getDebtLoadList = (date) => ({
  type: DEBTLOAD_LIST_REQUEST,
  payload: { date },
});

export const getDebtLoadListSuccess = (payload) => ({
  type: DEBTLOAD_LIST_SUCCESS,
  payload,
});

export const getDebtLoadListFailed = (payload) => ({
  type: DEBTLOAD_LIST_FAILED,
  payload,
});

export const getDebtLoadGroupRequest = (groupName) => ({
  type: GET_DEBT_LOAD_GROUP_REQUEST,
  payload: { groupName },
});

export const getDebtLoadGroupSuccess = (payload) => ({
  type: GET_DEBT_LOAD_GROUP_SUCCESS,
  payload,
});

export const updateDebtLoadGroup = (groupName, values) => ({
  type: UPDATE_DEBT_LOAD_GROUP_REQUEST,
  payload: { groupName, values },
});

export const updateDebtLoadGroupSuccess = (payload) => ({
  type: UPDATE_DEBT_LOAD_GROUP_SUCCESS,
  payload,
});

export const updateDebtLoadGroupFailed = (payload) => ({
  type: UPDATE_DEBT_LOAD_GROUP_FAILURE,
  payload,
});

export const fetchDebtLoadCalculate = (clientId, values) => ({
  type: FETCH_DEBT_LOAD_CALCULATE_REQUEST,
  payload: { clientId, values },
});

export const fetchDebtLoadCalculateSuccess = (payload) => ({
  type: FETCH_DEBT_LOAD_CALCULATE_SUCCESS,
  payload,
});

export const fetchDebtLoadCalculateFailed = (payload) => ({
  type: FETCH_DEBT_LOAD_CALCULATE_FAILED,
  payload,
});

export const resetDebtLoadCalculate = () => ({
  type: RESET_DEBT_LOAD_CALCULATE
});

export const getClientLastDebtLoad = (clientId, values) => ({
  type: GET_CLIENT_LAST_DEBT_LOAD_REQUEST,
  payload: { clientId, values },
});

export const getClientLastDebtLoadSuccess = (payload) => ({
  type: GET_CLIENT_LAST_DEBT_LOAD_SUCCESS,
  payload,
});

export const getClientLastDebtLoadFailed = (payload) => ({
  type: GET_CLIENT_LAST_DEBT_LOAD_FAILED,
  payload,
});

export const generateDebtLoadReport = (code, reportData, filename) => ({
  type: GENERATE_DEBT_OVERLOAD_REPORT,
  payload: { code, reportData, filename},
});

export const setIsSignedNotification = (payload) => ({
  type: IS_SIGNED_NOTIFICATION,
  payload,
});

export const fetchDebtLoadReportRequest = (payload) => ({
  type: FETCH_DEBT_LOAD_REPORT_REQUEST,
  payload,
});

export const fetchDebtLoadReportSuccess = (data) => ({
  type: FETCH_DEBT_LOAD_REPORT_SUCCESS,
  payload: data,
});

export const fetchDebtLoadReportFailed = (payload) => ({
  type: FETCH_DEBT_LOAD_REPORT_FAILED,
  payload,
});


export const calculateDebtLoadRequest = (clientId, amount, previousDealId, currentDealDuration) => ({
  type: CALCULATE_DEBT_LOAD_REQUEST,
  payload: { clientId, amount, previousDealId, currentDealDuration },
});